import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ["automaticScoutLimit", "numberAutomaticScoutLimit"];

  handleCompanySettingLimit(event) {
    let currentTarget = event.currentTarget;
    let maxVal = currentTarget.max ? parseInt(currentTarget.max) : 0;
    let newVal = currentTarget.value.replace(/[^0-9]/g, '');

    if (newVal) newVal = parseInt(newVal) > maxVal ? maxVal : parseInt(newVal);
    currentTarget.value = newVal;

    if (newVal && newVal > 0) {
      this.enableJobSettingLimit();
    } else {
      this.disableJobSettingLimit();
    }

    if (this.hasAutomaticScoutLimitTarget) {
      let usedVal = this.automaticScoutLimitTarget.getAttribute('used');
      usedVal = usedVal ? parseInt(usedVal) : 0;

      if (usedVal >= newVal && event.currentTarget == this.automaticScoutLimitTarget) {
        this.automaticScoutLimitTarget.classList.add('alert-danger');
      } else {
        this.automaticScoutLimitTarget.classList.remove('alert-danger');
      }
    }

    if (this.hasNumberAutomaticScoutLimitTarget) {
      let usedVal = this.numberAutomaticScoutLimitTarget.getAttribute('used');
      usedVal = usedVal ? parseInt(usedVal) : 0;
      let jobMaxLimitSetting = (newVal < usedVal ? 0 : newVal - usedVal);
      this.numberAutomaticScoutLimitTarget.max = jobMaxLimitSetting

      let jobLimitSettingVal = this.numberAutomaticScoutLimitTarget.value;
      this.numberAutomaticScoutLimitTarget.value = (jobLimitSettingVal && parseInt(jobLimitSettingVal) > jobMaxLimitSetting ? jobMaxLimitSetting : jobLimitSettingVal);

      if (usedVal >= newVal && event.currentTarget == this.numberAutomaticScoutLimitTarget) {
        this.numberAutomaticScoutLimitTarget.classList.add('alert-danger');
      } else {
        this.numberAutomaticScoutLimitTarget.classList.remove('alert-danger');
      }
    }
  }

  handleJobSettingLimit(event) {
    let currentTarget = event.currentTarget;
    let maxVal = currentTarget.max ? parseInt(currentTarget.max) : 0;
    let newVal = currentTarget.value.replace(/[^0-9]/g, '');

    if (newVal) newVal = parseInt(newVal) > maxVal ? maxVal : newVal;
    currentTarget.value = (newVal ? parseInt(newVal) : newVal);
  }

  disableJobSettingLimit() {
    if (this.hasNumberAutomaticScoutLimitTarget) this.numberAutomaticScoutLimitTarget.disabled = true;
  }

  enableJobSettingLimit() {
    if (this.hasNumberAutomaticScoutLimitTarget) this.numberAutomaticScoutLimitTarget.disabled = false;
  }
}
